<template>
    <!-- 个人订单操作 -->
    <div>
        <el-card class="container" v-show="!applicationPrePage  && !mallInvoiceApplyPage" shadow="never">
            <div slot="header">
                <div class="tabBar">
                    <div class="tabBar-item" :class="{'tabBar-itam-active': item.index == operateIndex, 'cursor-item': item.index != operateIndex}" v-for="item in tabBarList" :key="item.index" @click="changeOperate(item.index)"> {{ item.label }} </div>
                </div>
                <div class="desc"> {{ activeTabBarItem.desc }} </div>
                <div id="resetInput" class="topHandle">
                    <div v-show="[0, 1, 2, 3].includes(operateIndex)">
                        <el-input placeholder="输入订单编号" clearable v-model="orderListParams.orderCode">
                            <template slot="prepend">
                                <div>订单编号</div>
                            </template>
                        </el-input>
                    </div>
                    <div v-show="[4].includes(operateIndex)">
                        <el-input placeholder="输入订单编号" clearable v-model="orderListParams.orderNo">
                            <template slot="prepend">
                                <div>订单编号</div>
                            </template>
                        </el-input>
                    </div>
                    <div v-show="[4].includes(operateIndex)">
                        <el-input placeholder="输入商品名称" clearable v-model="orderListParams.productName">
                            <template slot="prepend">
                                <div>商品名称</div>
                            </template>
                        </el-input>
                    </div>
                    <div class="handle-item" v-show="operateIndex == 4">
                        <div class="item-title">支付方式</div>
                        <el-select size="small" v-model="orderListParams.payType" :clearable="false" placeholder="请选择支付方式">
                            <el-option
                              v-for="item in mallInvoicePayTypeList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-show="[0, 1, 2, 3].includes(operateIndex)">
                        <el-input placeholder="输入检测预约设备" clearable v-model="orderListParams.equipmentName">
                            <template slot="prepend">
                                <div>检测预约设备</div>
                            </template>
                        </el-input>
                    </div>
                    <div v-show="operateIndex == 2">
                        <el-input placeholder="请输入下单人" clearable v-model="orderListParams.clientName">
                            <template slot="prepend">
                                <div>下单人</div>
                            </template>
                        </el-input>
                    </div>
                    <div class="handle-item" v-show="[2,3].some(i => i == operateIndex)">
                        <div class="item-title">支付方式</div>
                        <el-select size="small" v-model="orderListParams.prepaidPayment" placeholder="请选择">
                            <el-option
                              v-for="item in prepaidPaymentList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="handle-item" v-show="[0, 1, 2, 3].includes(operateIndex)">
                        <div class="item-title">下单时间</div>
                        <el-date-picker
                          v-model="dateList"
                          size="small"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="changeDate"
                          >
                        </el-date-picker>
                    </div>
                    <div class="handle-item" v-show="[3].includes(operateIndex)">
                        <div class="item-title">开票状态</div>
                        <el-select v-model="orderListParams.billStatus" clearable size="small" placeholder="请选择">
                            <el-option
                              v-for="item in billStatusList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="header-button-box">
                    <el-button size="small" type="success" plain @click="searchList">搜索</el-button>
                    <el-button size="small" plain @click="changeOperate(operateIndex)">重置</el-button>
                </div>
            </div>
            <el-table v-if="operateIndex !== 4" key="detect-order-table" ref="table" :height="tableHeight" :header-cell-style="{background:'#F5F5F5'}" v-loading="loading" :data="orderList" :border="true" @selection-change="selectOrder">
                <el-table-column type="selection" width="55" align="center" :selectable="handleSelectable"></el-table-column>
                <el-table-column label="设备" width="140" align="center">
                    <template slot-scope="scope">
                        <img class="equipmentPic" :src="scope.row.equipmentPic" alt="">
                    </template>
                </el-table-column>
                <el-table-column label="订单号" prop="orderCode" width="200" align="center"></el-table-column>
                <el-table-column label="下单人" prop="clientName" width="100" align="center"></el-table-column>
                <el-table-column label="下单时间" prop="orderDate" width="150" align="center"></el-table-column>
                <el-table-column label="预约检测名称" prop="equipmentName" width="260" align="center"></el-table-column>
                <el-table-column label="样品总数" prop="sampleNumber" align="center"></el-table-column>
                <el-table-column label="检测金额（元）" width="120" align="center">
                    <template slot-scope="scope">
                        <span>￥ {{ scope.row.experimentTotalCost }} </span>
                    </template>
                </el-table-column>
                <el-table-column label="支付方式" width="100" align="center">
                    <template slot-scope="scope">
                        {{ dictFilter(scope.row.prepaidPayment ? scope.row.prepaidPayment.toString() : '-', 'prepaidPayment') }}
                    </template>
                </el-table-column>
                <el-table-column label="完成时间" prop="finishOrderDate" width="150" align="center"></el-table-column>
                <el-table-column label="订单备注" prop="customRemark" width="250" align="center"></el-table-column>
            </el-table>
            <el-table v-else key="mall-invoice-table" ref="table" :height="tableHeight" :header-cell-style="{background:'#F5F5F5'}" v-loading="loading" :data="orderList" :border="true" @selection-change="selectOrder">
                <el-table-column type="selection" width="55" align="center" :selectable="handleSelectable"></el-table-column>
                <el-table-column label="订单号" prop="orderNo" min-width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="商品名称" prop="firstGoodsName" min-width="240" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="订单价格" width="120" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.totalAmount }}</template>
                </el-table-column>
                <el-table-column label="支付方式" width="120" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.payTypeText || dictFilter(scope.row.payType ? scope.row.payType.toString() : '-', 'prepaidPayment') }}
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" prop="createdAt" width="180" align="center"></el-table-column>
            </el-table>
            <div class="table-footer">
                <div class="button-box">
                    <el-button type="primary" :disabled="!selectList.length" @click="operateButton(operateIndex)"> {{ operateButtonLabel }} </el-button>
                    <div v-if="[0, 1, 4].includes(operateIndex)">总计： ￥{{ experimentTotalCost }}</div>
                    <div v-if="[2, 3].includes(operateIndex)">共选中： {{ selectList.length }}条</div>
                </div>
                <el-pagination background v-if="total > 0" style="text-align: right;margin-top: 10px"
                    layout="total,prev, pager, next,sizes,jumper" :current-page="orderListParams.pageNum"
                    :page-size="orderListParams.pageSize" :total="total" @current-change="selPageChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-card>
        
        <!-- 立即还款弹框 -->
        <el-dialog title="温馨提示" :visible.sync="repayDialog" width="30%" :close-on-click-modal="false" @closed="closeRepayDialog">
            <div class="repay-dialog">
                <div class="repay-item">
                    <div class=item-title>还款金额：</div>
                    <div>￥ {{ experimentTotalCost }} </div>
                </div>
                <div class="repay-item">
                    <div class=item-title>支付方式：</div>
                    <div>预存支付</div>
                </div>
                <!-- <div class="repay-item">
                    <div class=item-title>支付方式：</div>
                    <div>
                        <el-radio v-model="repayment" label="1" border>预存支付</el-radio>
                        <el-radio v-model="repayment" label="2" border>微信支付</el-radio>
                    </div>
                </div>
                <div class="repay-item" v-show="repayment == 2">
                    <div class=item-title>微信支付码：</div>
                    <img class="wxQrCode" src="" alt="">
                </div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="repayDialog = false">取 消</el-button>
                <el-button type="primary" :loading="repayLoading"  @click="repay">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 申请开票 -->
        <applicationPre v-show="applicationPrePage" ref="applicationPre" @goBack="applicationPrePage = false" @backAndRefresh="backAndRefresh"></applicationPre>
        <!-- 耗材开票 -->
        <mallInvoiceApply v-if="mallInvoiceApplyPage" ref="mallInvoiceApply" @goBack="mallInvoiceApplyPage = false" @backAndRefresh="backMallInvoiceAndRefresh"></mallInvoiceApply>
    </div>
</template>

<script>
import { getClient } from "@/plugins/auth";
import { teamOrderList, helpRepaymentList, helpRepayment, orderRepayment, invoiceResultExport, mallInvoiceAvailableOrderList } from "@/api/request.js"
import applicationPre from './formPop/applicationPre.vue'
import mallInvoiceApply from './mallInvoiceApply.vue'

export default {
    components: { applicationPre, mallInvoiceApply },
    data() {
        return {
            userInfo: {},
            imgurl: process.env.VUE_APP_FILE_API,
            applicationPrePage: false,//是否显示申请开票页
            mallInvoiceApplyPage: false,//是否显示耗材开票组件
            loading: false,//table的loading
            repayDialog: false,//立即还款弹框
            repayLoading: false,//立即还款按钮防抖
            total: 0,
            operateIndex: 0,
            tabBarList: [
                { label: '立即还款', desc: '使用预付金额还款存在重复开票行为，此类订单无法开票，如已开票将以废票处理。', index: 0 },
				{ label: '帮ta还款', desc: '使用预付金额还款存在重复开票行为，此类订单无法开票，如已开票将以废票处理。', index: 1 },
				{ label: '耗材开票', desc: '团队信用支付的【已完成】订单可索取发票，信用与现金支付不可组合开票！', index: 4  },
				{ label: '开发票', desc: '个人财务支付的【已完成】订单可索取发票，信用与现金支付不可组合开票，2025年4月前的订单请联系客服开票！', index: 2 },
				{ label: '下载对账单', desc: '处于“已完成”状态的订单可下载对账单，对账单合并下载后将在同一个表格中统计，请按需提交下载。', index: 3 },
            ],
            billStatusList: [
              {label: '未开票', value: 1}, 
              {label: '已开票', value: 2},
              {label: '无需开票', value: 3},
            ],
            // 耗材开票接口排除预存支付，支付方式不可清空。
            mallInvoicePayTypeList: [
                // { label: '支付宝', value: '3' },
                // { label: '微信', value: '4' },
                { label: '个人信用', value: '5' },
                { label: '团队信用', value: '6' },
            ],
            dateList: [],
            // 订单列表查询接口上传参数
            orderListParams: {
                teamId: null,
                pageSize: 10,
				pageNum: 1,
            },
            orderList: [],//订单列表
            selectList: [],//勾选的订单列表
            repayment: '1',//还款支付方式
            orderRepaymentData: {},//预存还款接口上传参数
        }
    },
    computed: {
        activeTabBarItem() {
            return this.tabBarList.find(item => item.index == this.operateIndex) || this.tabBarList[0]
        },
        prepaidPaymentList() {
            let list = []
            if(this.operateIndex == 2) {
                list = [
                    {label: '个人信用', value: 5},  
                    {label: '团队信用', value: 6},
                ]
            }
            if(this.operateIndex == 3) {
                list = [
                    {label: '全部', value: ''},  
                    {label: '个人信用', value: 5},  
                    {label: '团队信用', value: 6},
                    {label: '团队预存', value: 2},
                ]
            }
            return list
        },
        tableHeight() {
            if(this.operateIndex == 3) {
                return 'calc(100vh - 500px)'
            } else {
                return 'calc(100vh - 450px)'
            }
        },
        operateButtonLabel() {
			let str = ''
			switch(this.operateIndex) {
				case 0:
				    str = '立即还款'
					break
				case 1:
                    str = '帮ta还款'
                    break
				case 2:
				    str = '立即开票'
					break
				case 3:
				    str = '下载对账单'
					break
                case 4:
				    str = '立即开票'
					break
			}
			return str
		},
        experimentTotalCost() {
			const list = []
            this.selectList.forEach(item => {
                const obj = this.orderList.find(item_ => item_.orderId == item)
                if(!obj) return
                if(this.operateIndex == 4) {
                    list.push(obj.paidAmount)
                } else {
                    list.push(obj.experimentTotalCost)
                }
			})
			const experimentTotalCost = list.reduce((sum, item) => {
				return sum + item
			}, 0)
			return experimentTotalCost.toFixed(2)
		},
    },
    created() {
        this.userInfo = JSON.parse(getClient())
        this.orderListParams.teamId = this.userInfo.teamId
    },
    mounted() {
        const routeOperateIndex = Number(this.$route.query.operateIndex)
        const defaultOperateIndex = this.tabBarList.some(item => item.index === routeOperateIndex) ? routeOperateIndex : 0
        this.changeOperate(defaultOperateIndex)
    },
    methods: {
        //获取订单列表
        async getOrderList() {
            if(this.operateIndex === 4) {
                await this.getMallInvoiceOrderList()
                return
            }
            this.loading = true
            const res = await teamOrderList(this.orderListParams)
            if(res.data.data.list.length) {
                res.data.data.list.forEach(item => {
			    	item.equipmentPic = (item.fileList && item.fileList.length) ? this.imgurl + item.fileList[0].url : ''
			    })
            }
            this.total = res.data.data.total;
            this.orderList = res.data.data.list
            this.loading = false
        },
        // 获取耗材待开票订单列表
        async getMallInvoiceOrderList() {
            try {
                this.loading = true
                // 耗材开票只查询后端判定的商城可开票订单，避免复用商城订单总列表造成状态口径偏差。
                const res = await mallInvoiceAvailableOrderList(this.orderListParams)
                const rows = this.extractMallOrderRows(res)
                this.orderList = rows.map(this.normalizeMallInvoiceOrder)
                this.total = this.extractMallOrderTotal(res, rows.length)
            } catch(err) {
                console.log(err)
                this.orderList = []
                this.total = 0
            } finally {
                this.loading = false
            }
        },
        // 重置耗材开票筛选条件
        resetMallInvoiceParams() {
            this.orderListParams = this.getDefaultMallInvoiceParams()
            this.getOrderList()
        },
        // 获取耗材开票默认查询参数
        getDefaultMallInvoiceParams() {
            return {
                subjectScope: 'TEAM', //团队类型的耗材订单开票
                pageSize: 10,
                pageNum: 1,
                orderNo: '',
                productName: '',
                payType: '6', // 默认查询团队信用订单，重置时恢复该支付方式。
            }
        },
        extractMallOrderRows(res) {
            const data = res && res.data
            if(Array.isArray(res && res.rows)) return res.rows
            if(data && Array.isArray(data.rows)) return data.rows
            if(data && Array.isArray(data.list)) return data.list
            if(data && data.data && Array.isArray(data.data.list)) return data.data.list
            return []
        },
        extractMallOrderTotal(res, fallback) {
            const data = res && res.data
            return Number((res && res.total) || (data && data.total) || (data && data.data && data.data.total)) || fallback
        },
        normalizeMallInvoiceOrder(item) {
            const amount = item.totalAmount != null
                ? item.totalAmount
                : (item.amount && item.amount.totalAmount != null ? item.amount.totalAmount : item.amount)
            return {
                ...item,
                orderId: item.orderId || item.id,
                orderNo: item.orderNo || item.id || '-',
                firstGoodsName: item.firstGoodsName || item.productName || item.goodsName || '-',
                totalAmount: Number(amount || 0).toFixed(2),
                createdAt: item.createdAt || item.addDate || '-'
            }
        },
        //更改页码
        async selPageChange(page) {
            this.clearTableCheck()
            this.orderListParams.pageNum = page;
            if(this.operateIndex == 1) {
                this.loading = true
                const helpRepaymentListRes = await helpRepaymentList(this.orderListParams)
                if(helpRepaymentListRes.rows.length) {
					helpRepaymentListRes.rows.forEach(item => {
                        item.equipmentPic = (item.fileList && item.fileList.length) ? this.imgurl + item.fileList[0].url : ''
					})
				}
                this.total = helpRepaymentListRes.total;
                this.orderList = helpRepaymentListRes.rows
                this.loading = false
            } else {
                this.getOrderList();
            }
        },
        // 更改页面item数量
        async handleSizeChange(val) {
            this.clearTableCheck()
            this.orderListParams.pageSize = val;
            if(this.operateIndex == 1) {
                this.loading = true
                const helpRepaymentListRes = await helpRepaymentList(this.orderListParams)
                if(helpRepaymentListRes.rows.length) {
					helpRepaymentListRes.rows.forEach(item => {
                        item.equipmentPic = (item.fileList && item.fileList.length) ? this.imgurl + item.fileList[0].url : ''
					})
				}
                this.total = helpRepaymentListRes.total;
                this.orderList = helpRepaymentListRes.rows
                this.loading = false
            } else {
                this.getOrderList();
            }
        },
        // 清空table的勾选
        clearTableCheck() {
            this.selectList = []
            this.$refs.table.clearSelection()
        },
        // 耗材开票订单是否可以勾选
        handleSelectable(row) {
            const key = this.operateIndex == 4 ? 'payType' : 'prepaidPayment'
            const pay1 = [1, 2, 5, 6]//平台支付方式
            const pay2 = [3, 4]//现金支付方式
            const data = this.orderList.find(i => i.orderId == this.selectList[0])
            if(![1, 4].includes(this.operateIndex) || !data) return true
            let rootType
            if(pay1.some(i => i == data[key])) rootType = 1
            else if(pay2.some(i => i == data[key])) rootType = 2
            else rootType = 3
            let targetType
            if(pay1.some(i => i == row[key])) targetType = 1
            else if(pay2.some(i => i == row[key])) targetType = 2
            else targetType = 3
            return targetType != 3 && targetType == rootType
        },
        //更改订单操作tab
        async changeOperate(index) {
            this.dateList = []
            this.operateIndex = index
            this.clearTableCheck()
            switch(index) {
				case 0:
				    // 立即还款
				    this.orderListParams = {
				    	teamId: this.userInfo.teamId,
				    	pageSize: 10,
				    	pageNum: 1,
				    	status: 7,
				    	paymentStatus: 1,
				    	billStatus: 1,
				    	prepaidPayment: 6
				    }
                    this.getOrderList()
					break
				case 1:
				    // 帮ta还款
				    this.orderListParams = {
				    	pageSize: 10,
						pageNum: 1,
				    	billStatus: 1,
				    }
                    this.loading = true
                    const helpRepaymentListRes = await helpRepaymentList(this.orderListParams)
                    if(helpRepaymentListRes.rows.length) {
						helpRepaymentListRes.rows.forEach(item => {
                            item.equipmentPic = (item.fileList && item.fileList.length) ? this.imgurl + item.fileList[0].url : ''
						})
					}
                    this.total = helpRepaymentListRes.total;
                    this.orderList = helpRepaymentListRes.rows
                    this.loading = false
					break
				case 2:
				    // 开发票
				    this.orderListParams = {
				    	teamId: this.userInfo.teamId,
				    	pageSize: 10,
				    	pageNum: 1,
				    	statuss: 7,
						billStatus: 1,
                        prepaidPayment: 6,
						noPrepaidPayments: '1,2',
						gteDetectionEndDate: '2025-04-01 00:00:00',
				    }
                    this.getOrderList()
					break
				case 3:
				    // 下载对账单
				    this.orderListParams = {
				    	teamId: this.userInfo.teamId,
				    	pageSize: 10,
				    	pageNum: 1,
				    	statuss: '7,9',
				    	billStatus: 1,
                        prepaidPayment: '',
				    }
                    this.getOrderList()
					break
                case 4:
                    // 耗材开票使用商城可开票订单接口，筛选参数与后端接口文档保持一致。
                    this.orderListParams = this.getDefaultMallInvoiceParams()
                    this.getOrderList()
                    break
			}
        },
        // 时间筛选
        changeDate(e) {
            this.orderListParams.orderDateBegin = e ? e[0] : ''
		    this.orderListParams.orderDateEnd = e ? e[1] : ''
        },
        // 表格支持逐行选择及表头全选，统一设置已选择的订单列表
        selectOrder(e) {
            this.selectList = e.map(item => item.orderId)
        },
        async searchList() {
            if(this.operateIndex == 1) {
                this.loading = true
                const res = await helpRepaymentList(this.orderListParams)
                if(res.rows.length) {
					res.rows.forEach(item => {
                        item.equipmentPic = (item.fileList && item.fileList.length) ? this.imgurl + item.fileList[0].url : ''
					})
				}
                this.total = res.total;
                this.orderList = res.rows
                this.loading = false
            } else {
                this.getOrderList()
            }
        },
        //操作按钮
        async operateButton(index) {
			switch(index) {
				case 0:
				    //立即还款
                    this.orderRepaymentData = {
						type: 1, //还款类型 1团队 2个人 
						relateId: this.userInfo.teamId, //操作ID
						orderIds: this.selectList, //订单ID
					}
                    this.repayDialog = true
					break
				case 1:
                    // 帮ta还款
                    this.$confirm('是否确认帮ta还款？', '温馨提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(async () => {
                        await helpRepayment({orderIds: this.selectList})
                        this.clearTableCheck()
                        this.$message.success('帮ta还款成功！')
                        this.changeOperate(index)
                    })
					break
				case 2:
				    //开发票
                    const invoiceList = []
			        this.selectList.forEach(item => {
			        	const obj = this.orderList.find(item_ => item_.orderId == item)
			        	invoiceList.push({
							orderId: obj.orderId,
							prepaidPayment: obj.prepaidPayment,
						})
			        })
                    this.applicationPrePage = true
                    this.$refs.applicationPre.init(1, invoiceList, this.experimentTotalCost)
					break
				case 3:
				    //下载对账单
                    const orderCodesList = []
                    this.selectList.forEach(item => {
                        const orderCode = this.orderList.find(item_ => item_.orderId == item).orderCode
                        orderCodesList.push(orderCode)
                    })
                    const exportRes = await invoiceResultExport({orderCodes: orderCodesList.join(',')})
                    await this.$download.name(exportRes.msg)
                    this.clearTableCheck()
					break
                case 4:
                    //耗材订单开票
                    this.goMallInvoiceApply({
                        orderIds: this.selectList,
                        subjectType: 'TEAM',
                        invoiceTotalMoney: this.experimentTotalCost
                    })
                    break
			}
        },
        // 关闭【立即还款】弹框
        closeRepayDialog() {
            this.repayment = '1'
        },
        //【立即还款】
        async repay() {
            this.repayLoading = true
            try {
                await orderRepayment(this.orderRepaymentData)
                this.repayLoading = false
                this.repayDialog = false
                this.clearTableCheck()
                this.$message.success('还款成功！')
                this.getOrderList()
            }
            catch {
                this.repayLoading = false
            }
        },
        //返回并刷新页面
        backAndRefresh() {
            this.applicationPrePage = false,
            this.clearTableCheck()
            this.getOrderList()
        },
        // 耗材开票返回并刷新列表
        backMallInvoiceAndRefresh() {
            this.mallInvoiceApplyPage = false
            this.getOrderList()
        },
        // 打开耗材开票组件
        goMallInvoiceApply(data) {
            this.mallInvoiceApplyPage = true
            this.$nextTick(() => {
                if(this.$refs.mallInvoiceApply) {
                    this.$refs.mallInvoiceApply.init(data)
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    // height: calc(100vh - 200px);
    .desc {
        display: flex;
        justify-content: center;
    	align-items: center;
    	height: 50px;
        font-size: 14px;
    	color: #FF4A2B;
        border: 1px solid #EBEEF5;
    	background-color: #FFF2F0;
    }
}
.equipmentPic {
    width: 100px;
    height: 100px;
}
.validate-false {
    border: 1px solid #FF4A2B;
    border-radius: 5px;
}

.header-button-box {
    padding: 0 15px 15px 15px;
    text-align: right;
    border: 1px solid #E8E8E8;
    border-top: none;
}

.tabBar {
    display: flex;
    width: 100%;
    .tabBar-item {
        cursor: pointer;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        border: 1px solid #EBEEF5;
        border-right: none;
        border-bottom: none;
    }
    .tabBar-item:last-child {
        border-right: 1px solid #EBEEF5;
    }
    .cursor-item:hover {
        color: #fff;
        font-weight: 600;
        background-color: #84B7F950;
    }
    .tabBar-itam-active {
        color: #fff;
        font-weight: 600;
        background-color: #84B7F9;
    }
}

.topHandle {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 15px;
    border: 1px solid #E8E8E8;
    border-top: none;
    border-bottom: none;
    .handle-item {
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        align-items: center;
        height: 40px;
        padding-right: 5px;
        border: 1px solid #E8E8E8;
        border-radius: 5px;
    }
    .item-title {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        margin-right: 5px;
        padding: 0 10px;
        word-break: keep-all;
        font-size: 14px;
        color: #909399;
        background-color: #F5F7FA;
    }
}
.timePicker {
    height: 40px;
    margin-bottom: 20px;
}
.table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    .button-box {
        display: flex;
        column-gap: 15px;
        align-items: center;
        height: 60px;
        color: #FF4A2B;
    }
}
.repay-dialog {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    .repay-item {
        display: flex;
        .item-title {
            width: 100px;
        }
        .wxQrCode {
            width: 200px;
            height: 200px;
            border-radius: 10px;
            border: 1px solid #ddd;
            background-color: pink;
        }
    }

}

</style>